import { Table } from 'react-dsgov';
import styles from './balnearioDetalhes.module.scss';
import { formatCurrency } from '../../../../../../../../../../utils/formatCurrency';
import { IOperacaoBalnearioResumo, IOutrosRegimesTributo } from '../../../../../../../../../../interfaces/IOperacoes';

interface IHeader {
  field: string;
  label: string;
  format?: Function;
}

interface IFooter {
  value: string;
  colspan?: number;
  show?: boolean;
}

interface IProps {
  data: IOperacaoBalnearioResumo;
}

function BalnearioDetalhes({ data }: IProps) {
  const TABELA_CABECALHO: IHeader[] = [
    {
      field: 'id',
      label: 'Id',
    },
    {
      field: 'codigoNcm',
      label: 'Código NCM',
    },
    {
      field: 'houveBanho',
      label: 'Preço Banho Especificado',
      format: (value: boolean) => formataBoolean(value),
    },
  ];

  if (data?.houveBanho) {
    TABELA_CABECALHO.push(
      {
        field: 'valorBanho',
        label: 'Valor Total dos Banhos(R$)',
        format: formatCurrency,
      },
      {
        field: 'qtdeBanho',
        label: 'Quantidade de Banhos',
      },
      {
        field: 'valorPrecoMedio',
        label: 'Preço Médio (R$)',
        format: formatCurrency,
      },
      { field: 'valorBaseCalculo', label: 'Base de Cálculo(R$)', format: formatCurrency }
    );
  } else {
    TABELA_CABECALHO.push(
      { field: 'valorReceitaBruta', label: 'Receita Bruta(R$)', format: formatCurrency },
      { field: 'tributosValores', label: 'Deduções(R$)' },
      { field: 'valorReceitaLiquida', label: 'Receita Líquida(R$)', format: formatCurrency },
      { field: 'valorBaseCalculo', label: 'Base de Cálculo(R$)', format: formatCurrency }
    );
  }

  const TABELA_RODAPE: IFooter[] = [{ value: '', colspan: TABELA_CABECALHO.length }];

  function formataBoolean(valor: boolean) {
    return valor ? 'Sim' : 'Não';
  }

  function colunaDeducoes(tributos: IOutrosRegimesTributo[], valorTotalTributos: number) {
    let content: JSX.Element[] = [];

    tributos.forEach((item: IOutrosRegimesTributo) => {
      content.push(
        <div className={styles.deducoes} key={item.id}>
          <span>{item.nome}:</span> {formatCurrency(item.valor)}
        </div>
      );
    });
    content.push(
      <div className={styles.deducoes} key={'x'}>
        <span>Total:</span> {formatCurrency(valorTotalTributos)}
      </div>
    );

    return content;
  }

  return (
    <div className={styles.secao}>
      <div className={styles.tabela}>
        <Table
          showTopBar={false}
          headers={TABELA_CABECALHO}
          showPagination={false}
          showDensityButtons={false}
          showSearch={false}
          density='medium'
          tabIndex={0}
        >
          <tbody>
            {data ? (
              <tr key={data.codigoNcm} data-testid='linha-dados'>
                {TABELA_CABECALHO.map((header, index) => (
                  <>
                    <td key={header.field} className={styles.tableCell}>
                      {header.format
                        ? header.format(data[header.field as keyof IOperacaoBalnearioResumo])
                        : header.field === 'tributosValores'
                          ? colunaDeducoes(
                              data[header.field as keyof IOperacaoBalnearioResumo] as IOutrosRegimesTributo[],
                              data.valorTotalTributos ?? 0
                            )
                          : (data[header.field as keyof IOperacaoBalnearioResumo] ?? '')}
                    </td>
                  </>
                ))}
              </tr>
            ) : (
              <tr>
                {' '}
                <th className={`border-right`} rowSpan={1} scope='rowgroup'></th>
                <td colSpan={5} className={styles.noOperacoes} data-testid='sem-operacao'>
                  Não há operações cadastradas
                </td>
              </tr>
            )}
          </tbody>

          <tfoot>
            <tr>
              {TABELA_RODAPE.map((footer, index) => (
                <td key={index} colSpan={footer.colspan ?? 1}>
                  {footer.show ?? footer.value}
                </td>
              ))}
            </tr>
          </tfoot>
        </Table>
      </div>
    </div>
  );
}

export default BalnearioDetalhes;
